<template>
  <main>
    <!-- Hero section -->
    <div
      class="relative bg-cover bg-center"
      :style="{
        backgroundImage: `url(${require('../assets/images/Gmdddddddddddd.png')})`,
      }"
    >
      <div class="absolute inset-0 bg-black bg-opacity-50"></div>
      <div
        class="relative md:px-12 sm:px-12 px-2 max-w-screen-2xl mx-auto z-10 h-screen flex items-center justify-start text-white"
      >
        <!-- MMC Section -->
        <h1 class="text-4xl md:text-6xl font-bold">
          Mshel Real Estate Mentorship Class (MREM Class)
        </h1>
      </div>
    </div>

    <!-- Three cards section -->
    <section class="container md:px-12 sm:px-12 px-2 max-w-screen-2xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 py-20">
        <!-- Vision Card -->
        <div
          class="card shadow-lg border border-none rounded-lg p-6 cursor-pointer"
        >
          <div
            class="icon mb-3 flex items-center justify-center hover:scale-105 transition-transform duration-200"
          >
            <i class="fa-brands fa-think-peaks text-4xl text-blue"></i>
          </div>
          <h3 class="text-center text-2xl font-semibold mb-3">Vision</h3>
          <p class="text-center text-sm text-gray-700">
            To create a transformative space where individuals embark on a
            journey of personal and professional growth, leading to a ripple
            effect of positive transformation in their lives and the lives of
            those they touch.
          </p>
        </div>

        <!-- Mission Card -->
        <div
          class="card shadow-lg border border-none rounded-lg p-6 cursor-pointer"
        >
          <div
            class="icon mb-3 flex items-center justify-center hover:scale-105 transition-transform duration-200"
          >
            <i class="fa-brands fa-battle-net text-4xl text-blue"></i>
          </div>
          <h3 class="text-center text-2xl font-semibold mb-3">Mission</h3>
          <p class="text-center text-sm text-gray-700">
            We provide a dynamic learning environment where mentorship becomes a
            catalyst for personal and professional success, creating a positive
            impact and helping people reach their highest potential.
          </p>
        </div>

        <!-- Core Values Card -->
        <div
          class="card shadow-lg border border-none rounded-lg p-6 cursor-pointer"
        >
          <div
            class="icon mb-3 flex items-center justify-center hover:scale-105 transition-transform duration-200"
          >
            <i class="fa-brands fa-openid text-4xl text-blue"></i>
          </div>
          <h3 class="text-center text-2xl font-semibold mb-3">Core Values</h3>
          <div class="space-y-2">
            <p class="text-left text-sm text-gray-700 flex items-center">
              <i class="fa-brands fa-pushed text-blue mr-2 font-black"></i>
              Integrity
            </p>
            <p class="text-left text-sm text-gray-700 flex items-center">
              <i class="fa-brands fa-pushed text-blue mr-2 font-black"></i>
              Innovative and continuous learning
            </p>
            <p class="text-left text-sm text-gray-700 flex items-center">
              <i class="fa-brands fa-pushed text-blue mr-2 font-black"></i>
              Leadership development and empowerment
            </p>
            <p class="text-left text-sm text-gray-700 flex items-center">
              <i class="fa-brands fa-pushed text-blue mr-2 font-black"></i>
              Collaboration
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Value Proposition Section-->
    <valueProposition />

    <!-- Training Topics Section-->
    <section
      class="container py-32 md:px-12 sm:px-12 px-4 max-w-screen-2xl mx-auto bg-cover bg-center"
      :style="{
        backgroundImage: `url(${require('../assets/images/hero-section.jpg')})`,
      }"
    >
      <div class="bg-black bg-opacity-50"></div>
      <h1 class="text-lg font-bold lg:text-start text-[#ada595] mb-8 -mt-6">
        Training Topics
      </h1>
      <!-- First Row Trainings -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
        <!-- Card Component -->
        <div
          class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border hover:border-blue px-6 py-16 cursor-pointer flex flex-col items-center justify-center transition-all"
        >
          <h3
            class="text-center text-base font-medium mb-3 group-hover:invisible"
          >
            Introduction To Real Estate
          </h3>
          <div
            class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <h3 class="text-center p-4 font-normal text-sm">
              This module offers comprehensive instruction on property
              transactions, investment strategies, and legal considerations,
              preparing students for success in the industry.
            </h3>
          </div>
        </div>

        <!-- Additional Cards -->
        <div
          class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border hover:border-blue px-6 py-16 cursor-pointer flex flex-col items-center justify-center transition-all"
        >
          <h3
            class="text-center text-base font-medium mb-3 group-hover:invisible"
          >
            Venturing into Nigeria Real Estate System
          </h3>
          <div
            class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <h3 class="text-center p-4 font-normal text-sm">
              This module offers opportunities for investment and development in
              a rapidly growing market, with potential for lucrative returns.
            </h3>
          </div>
        </div>

        <div
          class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border hover:border-blue px-6 py-16 cursor-pointer flex flex-col items-center justify-center transition-all"
        >
          <h3
            class="text-center text-base font-medium mb-3 group-hover:invisible"
          >
            Real Estate Management & Sustainability Planning
          </h3>
          <div
            class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <h3 class="text-center p-4 font-normal text-sm">
              This module helps participants to create environmentally
              responsible properties while maximizing value and long-term impact
              in the real estate industry.
            </h3>
          </div>
        </div>

        <div
          class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border hover:border-blue px-6 py-16 cursor-pointer flex flex-col items-center justify-center transition-all"
        >
          <h3
            class="text-center text-base font-medium mb-3 group-hover:invisible"
          >
            Investment Strategy and Methodology
          </h3>
          <div
            class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <h3 class="text-center p-4 font-normal text-sm">
              Learn how to create environmentally responsible properties while
              maximizing value and long-term impact in the real estate industry.
            </h3>
          </div>
        </div>
      </div>

      <!-- Second Row Trainings -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mt-8">
        <div
          class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border hover:border-blue px-6 py-16 cursor-pointer flex flex-col items-center justify-center transition-all"
        >
          <h3
            class="text-center text-base font-medium mb-3 group-hover:invisible"
          >
            Real Estate Business Development System
          </h3>
          <div
            class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <h3 class="text-center p-4 font-normal text-sm">
              Strategies for market analysis, client acquisition, and growth
              management in the competitive real estate industry.
            </h3>
          </div>
        </div>

        <div
          class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border hover:border-blue px-6 py-16 cursor-pointer flex flex-col items-center justify-center transition-all"
        >
          <h3
            class="text-center text-base font-medium mb-3 group-hover:invisible"
          >
            Marketing & Branding
          </h3>
          <div
            class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <h3 class="text-center p-4 font-normal text-sm">
              Learn to create impactful campaigns, build brand identity, and
              leverage digital platforms effectively.
            </h3>
          </div>
        </div>

        <div
          class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border hover:border-blue px-6 py-16 cursor-pointer flex flex-col items-center justify-center transition-all"
        >
          <h3
            class="text-center text-base font-medium mb-3 group-hover:invisible"
          >
            Real Estate Legal System
          </h3>
          <div
            class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <h3 class="text-center p-4 font-normal text-sm">
              Educates participants on property laws, contracts, and regulations
              for navigating legal complexities in real estate.
            </h3>
          </div>
        </div>

        <div class="hidden">
          <div
            class="bg-white group relative hover:bg-blue hover:text-white shadow-lg border hover:border-blue px-6 py-16 cursor-pointer flex flex-col items-center justify-center transition-all"
          >
            <h3
              class="text-center text-base font-medium mb-3 group-hover:invisible"
            >
              Wealth Management
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                Investment strategies, financial planning, and risk mitigation
                techniques for long-term financial security.
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Training Plan Section -->
    <section
      class="container py-12 md:px-12 sm:px-12 px-4 max-w-screen-2xl mx-auto"
    >
      <div>
        <div>
          <h2 class="text-3xl font-bold tracki text-center mt-12 sm:text-5xl">
            Pricing
          </h2>
          <p class="max-w-3xl mx-auto mt-4 text-xl text-center">
            Get started on our free plan and upgrade when you are ready.
          </p>

          <!-- toggle pricing -->
          <!-- <div class="mt-16 flex items-center justify-center">
              <label for="toggle" class="inline-flex items-center cursor-pointer">
                <span class="mr-8 text-2xl font-semibold">Monthly</span>
                <div
                  class="w-14 h-6 bg-white rounded-full shadow-lg transition duration-200 ease-in-out"
                >
                  <div :class="toggleClass"></div>
                </div>
                <span class="ml-8 text-2xl font-semibold">Yearly</span>
              </label>
              <input
                type="checkbox"
                id="toggle"
                class="hidden"
                v-model="isToggle"
                @change="toggleYearly"
              />
            </div> -->
        </div>

        <div
          class="mt-24 container space-y-12 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-x-8"
        >
          <div
            v-for="(item, index) in trainingData"
            :key="item.id"
            class="relative p-8 border border-gray-200 rounded-2xl shadow-sm flex flex-col"
          >
            <!-- Add "Most Popular" Label -->
            <div
              v-if="index === 2"
              class="absolute top-0 right-0 mr-8 bg-blue text-white text-base font-bold px-3 py-1 rounded-full -mt-4"
            >
              Most Popular
            </div>

            <div class="flex-1">
              <h3 class="text-xl font-semibold text-center">
                {{ item.name }} <br />
                <!-- <span> {{ item.details }} </span> -->
              </h3>
              <p class="mt-6 text-center">{{ item.category }}</p>
              <p class="mt-10 flex items-baseline justify-center">
                <span class="text-lg tracking-tight">
                  {{ item.cost }}
                </span>
                <!-- <span class="ml-1 text-xl"
                    >/ month(s)</span
                  > -->
              </p>
              <ul role="list" class="mt-10 space-y-6">
                <li class="flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="flex-shrink-0 w-6 h-6 text-blue"
                    aria-hidden="true"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  <span class="ml-3">Duration: {{ item.duration }} months</span>
                </li>
                <li class="flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="flex-shrink-0 w-6 h-6 text-blue"
                    aria-hidden="true"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  <span class="ml-3">Schedule: {{ item.schedule }}</span>
                </li>
              </ul>
            </div>
            <router-link
              class="bg-sky-100 text-blue hover:bg-blue hover:text-white mt-8 block w-full py-3 px-6 border border-transparent rounded-md text-center font-medium"
              :to="`/mshel-realestate-masterclass-club/registration-form/${item.id}`"
              v-if="item.category === 'Free'"
              @click="scrollToTop"
            >
              Signup for free
            </router-link>

            <router-link
              class="bg-blue text-white hover:bg-sky-100 hover:text-blue mt-8 block w-full py-3 px-6 border border-transparent rounded-md text-center font-medium"
              :to="`/mshel-realestate-masterclass-club/registration-form/${item.id}`"
              v-else
              @click="scrollToTop"
            >
              Get Started
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import valueProposition from "../components/valueProposition.vue";
import apiService from "../services/apiService";

export default {
  name: "masterclass-club",
  components: {
    valueProposition,
  },
  data() {
    return {
      isToggle: false,
      trainingData: [],
    };
  },
  mounted() {
    this.fetchTrainingData();
  },
  methods: {
    async fetchTrainingData() {
      try {
        const response = await apiService.getTrainingTypeMrem();
        // Populate only the `data` array into `trainingData`
        this.trainingData = response.data.data;
        console.log("Training Data:", this.trainingData);
      } catch (error) {
        console.error("Error fetching training data:", error);
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    toggleYearly() {
      console.log("isToggle state:", this.isToggle);
    },
  },
  computed: {
    toggleClass() {
      return [
        "w-6",
        "h-6",
        "rounded-full",
        "transition",
        "duration-200",
        "ease-in-out",
        this.isToggle ? "bg-blue ml-8" : "bg-gray-500",
      ];
    },
  },
};
</script>

<style scoped>
.card {
  transition: transform 0.2s ease;
}
.card:hover {
  transform: scale(1.02);
}
</style>
